// import { Routes, Route } from "react-router-dom";
// import Login from "./pages/login";
// import Dashboard from "./pages/dashboard";
// import Navbar from "./components/navbar";

// function App() {
//   return (
//     <>
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/dashboard" element={<Dashboard />} />
//       </Routes>
//     </>
//   );
// }

// export default App;

// __________________________________________________________________________________________________

// import { Routes, Route, useLocation } from "react-router-dom";
// import Login from "./pages/login";
// import Dashboard from "./pages/dashboard";
// import Navbar from "./components/navbar";

// function App() {
//   const location = useLocation();
//   const showNavbar = location.pathname !== "/"; // Mostra Navbar solo se NON siamo nella login

//   return (
//     <>
//       {showNavbar && <Navbar />}
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="*" element={<h1>404 - Pagina non trovata</h1>} />
//       </Routes>
//     </>
//   );
// }

// export default App;

// __________________________________________________________________________________________________

// import { Routes, Route, useLocation } from "react-router-dom";
// import Login from "./pages/login";
// import Navbar from "./components/navbar";
// import ProtectedRoute from "./components/protectedRoute";
// import Dashboard from "./pages/dashboard";
// import Profile from "./pages/profile";
// import NotFound from "./pages/notFound";

// function App() {
//   const location = useLocation();
//   const showNavbar = location.pathname !== "/";

//   return (
//     <>
//       {showNavbar && <Navbar />}
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
//         <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
//         <Route path="*" element={<NotFound />} />
//       </Routes>
//     </>
//   );
// }

// export default App;

// __________________________________________________________________________________________________

// import { Routes, Route, useLocation } from "react-router-dom";
// import Login from "./pages/login";
// import Navbar from "./components/navbar";
// import ProtectedRoute from "./components/protectedRoute";
// import Dashboard from "./pages/dashboard";
// import Profile from "./pages/profile";
// import Registry from "./pages/registry";
// import Statistics from "./pages/statistics";
// import Notifications from "./pages/notifications";
// import Settings from "./pages/settings";
// import NotFound from "./pages/notFound";

// function App() {
//   const location = useLocation();
//   const showNavbar = location.pathname !== "/" && location.pathname !== "/404";

//   return (
//     <>
//       {showNavbar && <Navbar />}
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
//         <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
//         <Route path="/registry" element={<ProtectedRoute><Registry /></ProtectedRoute>} />
//         <Route path="/statistics" element={<ProtectedRoute><Statistics /></ProtectedRoute>} />
//         <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
//         <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
//         <Route path="*" element={<NotFound />} />
//       </Routes>
//     </>
//   );
// }

// export default App;

// ____________________________________________________________________________________________________________

import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Login from "./pages/login";
import Navbar from "./components/navbar";
import ProtectedRoute from "./components/protectedRoute";
import Dashboard from "./pages/dashboard";
import Profile from "./pages/profile";
import Registry from "./pages/registry";
import Statistics from "./pages/statistics";
import Notifications from "./pages/notifications";
import Settings from "./pages/settings";
import NotFound from "./pages/notFound";

function App() {
  const location = useLocation();
  const showNavbar = location.pathname !== "/" && location.pathname !== "/notfound";

  return (
    <>
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/registry" element={<ProtectedRoute><Registry /></ProtectedRoute>} />
        <Route path="/statistics" element={<ProtectedRoute><Statistics /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/notfound" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/notfound" />} />
      </Routes>
    </>
  );
}

export default App;